import type { CodeableConcept, Quantity } from '@medplum/fhirtypes';
import type { Assessment } from '../pages/clients/data';

/**
 * Map app Assessment to FHIR CodeableConcept for assessment type (e.g. PHQ-9, GAD-7).
 */
export function getAssessmentCodeableConcept(assessment: Assessment): CodeableConcept {
  const display = assessment.assessmentType ?? 'Unknown';
  return {
    coding: [
      {
        system: 'http://loinc.org',
        code: assessment.assessmentType?.replace(/-/g, '') ?? 'unknown',
        display,
      },
    ],
    text: display,
  };
}

/**
 * Map app Assessment score to FHIR Quantity for display.
 */
export function getAssessmentQuantity(assessment: Assessment): Quantity {
  const value = assessment.score ?? 0;
  const unit = assessment.maxScore != null ? `/${assessment.maxScore}` : undefined;
  return {
    value,
    ...(unit && { unit }),
  };
}

/**
 * Map app Assessment severity to FHIR CodeableConcept for interpretation.
 */
export function getAssessmentInterpretation(assessment: Assessment): CodeableConcept | undefined {
  const text = assessment.severity?.trim();
  if (!text) return undefined;
  return {
    text,
  };
}
